import firebase from "firebase/app";
import "firebase/firestore";

// Initialize Firebase
var config = {
	apiKey: "AIzaSyAMzlL7oB8ldqPabyro_DcBh_6MkVyf60U",
	authDomain: "coach-in-the-pocket.firebaseapp.com",
	databaseURL: "https://coach-in-the-pocket.firebaseio.com",
	projectId: "coach-in-the-pocket",
	storageBucket: "coach-in-the-pocket.appspot.com",
	messagingSenderId: "412224065710",
	appId: "1:412224065710:web:f59829a9d9211c5fb69d3f",
	measurementId: "G-VN8VTJPZJT"
};

firebase.initializeApp(config);
